import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  Optional,
} from '@angular/core';

import { IconName } from './icon.types';
import { ISS_ICONS_PATH } from './icon.config';

import { FileHashPipe } from '@iss/wo-common/hash-files';

@Component({
  selector: 'iss-icon',
  templateUrl: './icon.component.html',
  styleUrls: [ './icon.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ FileHashPipe ],
})
export class IconComponent {
  private readonly path: string;

  @Input({ required: true }) public name!: IconName;

  public constructor(@Optional() @Inject(ISS_ICONS_PATH) path: string | undefined) {
    this.path = path || 'core/icons';
  }

  public get src(): string {
    return `${ this.path }/icons.svg#${ this.name }`;
  }
}
